import classnames from 'classnames/bind'
import React from 'react'
import { GlobalThemeColors } from '~/@types/colors'

import Spinner from '~/components/Abstracts/Spinner'

import { useTheme } from '~/providers/ThemeProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type LoadingPageProps = {
  className?: string
  color?: string
}

function LoadingPage({ color, className }: LoadingPageProps) {
  const { colors } = useTheme()

  return (
    <section className={cx(css.loader, className)}>
      <Spinner
        className={css.spinner}
        color={colors?.[color ?? GlobalThemeColors.Black]}
      />
    </section>
  )
}

LoadingPage.defaultProps = {}

export default LoadingPage
